import React from 'react'
import { Outlet } from 'react-router-dom'

const Page = () => <Outlet />

export default Page
